import { selectedAddress, duplexAddress } from './ServiceAddress';
import util from '../lib/util';
import * as consts from '../constants';

const selectProjectModel = (state) => {
    switch (state.gas.pageName) {
        case consts.NEW_GAS_LINE_NAME:
            return selectProjectModelNewGasLine(state);
        case consts.SERVICE_REMOVAL_NAME:
            return selectProjectModelServiceRemoval(state);
    }
};
const selectProjectModelNewGasLine = (state) => {
    const f = state.form;
    const g = state.gas;


    const GasContractor = f.contractorCompanyName || f.contractorName ?
        {
            CompanyName: f.contractorCompanyName,
            Name: f.contractorName,
            WorkPhone: util.formatCafePhoneNumber(f.contractorPrimaryPhone + f.contractorPrimaryPhone_ext),
            CellPhone: util.formatCafePhoneNumber(f.contractorSecondaryPhone)
        } : null;
    const appliances1 = getAppliances(f);
    const appliances2 = getAppliances(f, 2);
    const Premise1 = {
        Appliances: appliances1.cafe,
        SquareFootage: +f.buildingFootage,
        Unit: f.unitNumber
    };
    let Premise2 = null;
    //TODO: fix it for duplex
    if (f.duplexMeterCount && f.buildingType == "2" && f.duplexMeterCount == "2") {
        Premise2 = {
            Appliances: appliances2.cafe,
            SquareFootage: +f.buildingFootage2,
            Unit: f.unitNumber
        };
    }
    const rowPrimarySiteContact = (f.workSiteContact == 1) ?
        {
            CompanyName: f.accountHolderInfo_businessInfo_businessName || (f.accountHolderInfo_residentInfo_firstName + " " + f.accountHolderInfo_residentInfo_lastName),
            Name: f.accountHolderInfo_residentInfo_firstName + " " + f.accountHolderInfo_residentInfo_lastName,
            businessPhone: f.accountHolderInfo_phoneContact_primaryPhone,
            businessPhoneExt: f.accountHolderInfo_phoneContact_primaryPhone_ext,
            mobilePhone: f.accountHolderInfo_phoneContact_primaryCellPhone
        }
        :
        {
            CompanyName: f.workSiteContactName,
            Name: f.workSiteContactName,
            businessPhone: f.workSiteContactPhone,
            businessPhoneExt: f.workSiteContactPhone_ext,
            mobilePhone: f.workSiteContactPhone,
            position: f.workSiteContactPoistion
        };
    const PrimarySiteContact = (f.workSiteContact == 1) ?
        {
            CompanyName: f.accountHolderInfo_businessInfo_businessName,
            Name: f.accountHolderInfo_residentInfo_firstName + " " + f.accountHolderInfo_residentInfo_lastName,
            WorkPhone: util.formatCafePhoneNumber(f.accountHolderInfo_phoneContact_primaryPhone + f.accountHolderInfo_phoneContact_primaryPhone_ext),
            CellPhone: util.formatCafePhoneNumber(f.accountHolderInfo_phoneContact_primaryCellPhone)
        }
        :
        {
            CompanyName: f.workSiteContactName,
            Name: f.workSiteContactName,
            WorkPhone: util.formatCafePhoneNumber(f.workSiteContactPhone + f.workSiteContactPhone_ext),
            CellPhone: util.formatCafePhoneNumber(f.workSiteCellPhone),
            position: f.workSiteContactPoistion
        };

    const ownerResItems = window.osa.lookup.customerDetails.isOwnerResidential.items;
    const ownerComItems = window.osa.lookup.customerDetails.isOwnerCommercial.items;
    let CustomerSubType = f.customerType != "1" ?
        util.getNamebyId(ownerComItems, f.isOwner) : util.getNamebyId(ownerResItems, f.isOwner);
    CustomerSubType = f.isOwner + ":" + CustomerSubType;
    const buildingTypeName = util.getNamebyId(window.osa.lookup.serviceAddress.buildingType.items, f.buildingType);
    const address = selectedAddress(state);
    const address2 = duplexAddress(state);

    const gdpItems = address && address.city == 'Revelstoke' ? window.osa.lookup.projectSpecifics.gasDeliveryPressure.itemsRevelstoke
        : window.osa.lookup.projectSpecifics.gasDeliveryPressure.items;
    const dp = util.getNamebyId(gdpItems, f.gasDeliveryPressure);

    const CafeData = {
        BpNumber: g.user.bpNumber,
        BaNumber: g.baNumber,
        ProjectNo: g.project && g.project.data && g.project.data.projectNo,
        BuildingType: buildingTypeName,
        DeliveryPressure: dp,
        GasContractor,
        IsBuilder: (f.customerType && f.customerType == "3"),
        IsBusiness: (f.customerType && f.customerType != "1"),
        IsNewBp: (f.fortisBCAccount && f.fortisBCAccount == 1),
        IsNewBuilding: f.buildingCondition == "New",
        IsSingleMeter: (f.buildingType == "2" && f.duplexMeterCount == "2") ? false : true,
        IsSingleMeterLocation: f.duplexSecondMeterLocation && f.duplexSecondMeterLocation == "2" ? false : true,
        MeterLocation: util.getNamebyId(window.osa.lookup.projectSpecifics.meterLocation.items, f.meterLocation),
        Premise1,
        Premise2,
        PrimarySiteContact,
        CustomerSubType,
        ServiceOrders: [{
            StartDate: g.schedule && g.schedule.clickStartDate,
            EndDate: g.schedule && g.schedule.clickEndDate,
            ScheduleStartDate: g.schedule && g.schedule.scheduleStartDate,
            ScheduleEndDate: g.schedule && g.schedule.scheduleEndDate,
        }],
    };
    const nullAddress = {
        id: 0, unitNumber: null, streetNumber: null, streetName: null, postCode: null, poBox: null,
        addressSubType: { id: 0, name: null, sortOrder: 0 },
        addressType: { id: 0, name: null, sortOrder: 0 },
        city: { id: 0, name: null, sortOrder: 0 },
        coordinate: { id: 0, lat: 0, lng: 0 },
        country: { id: 0, name: null, sortOrder: 0 },
        province: { id: 0, name: null, sortOrder: 0 },
        streetDirection: { id: 0, name: null, sortOrder: 0 },
        streetType: { id: 0, name: null, sortOrder: 0 },
    };
    const gasContractor = {
        id: 0,
        address: nullAddress,
        businessPhone: f.contractorPrimaryPhone || "",
        businessPhoneExt: f.contractorPrimaryPhone_ext || "",
        company: f.contractorCompanyName || "",
        contactType: { id: 0, name: null, sortOrder: 0 },
        dob: null,
        firstName: null,
        fullName: f.contractorName || "",
        lastName: null,
        mobilePhone: f.contractorSecondaryPhone || "",
    };

    const projectAddress = address && address.city ? getAddressForProject(address) : null;
    const projectAddress2 = address2 && address2.city ? getAddressForProject(address2) : null;
    const workSiteContact = {
        address: nullAddress,
        businessPhone: rowPrimarySiteContact.businessPhone || "",
        businessPhoneExt: rowPrimarySiteContact.businessPhoneExt || "",
        company: rowPrimarySiteContact.CompanyName || "",
        contactType: { id: 0, name: null, sortOrder: 0 },
        dob: null,
        firstName: null,
        id: 0,
        lastName: null,
        mobilePhone: rowPrimarySiteContact.mobilePhone || "",
        position: rowPrimarySiteContact.position || ""
    };
    const obstacleDescription = getObstacleDescription(state);
    const Project = {
        applianceCounts: appliances1.project,
        buildingType: { id: +f.buildingType, name: buildingTypeName, sortOrder: 1 },
        deliveryPressure: { id: 1, name: dp, sortOrder: 1 },
        gasContractor,
        hasObstacle: obstacleDescription.length > 0,//TODO
        isCustomerContractor: f.customerType == "3",
        isCustomerTheOwner: f.isOwner == 4,
        isNaturalGasAvailable: !(g.parcel && g.parcel.isOutsideGasArea),
        isNewBuilding: f.buildingCondition == "New",
        isSameMeterLocation: f.duplexSecondMeterLocation && f.duplexSecondMeterLocation == "2" ? false : true,
        meterLocation: { id: 2, name: util.getNamebyId(window.osa.lookup.projectSpecifics.meterLocation.items, f.meterLocation), sortOrder: 2 },
        metersRequired: (f.buildingType == "2" && f.duplexMeterCount == "2") ? 2 : 1,
        obstacleDescription,//TODO
        projectAddress,
        projectAddress2,
        projectType: { id: 2, name: "New Service Attachment", sortOrder: 2 },
        schedule: { id: 0, weekNumber: 0, year: 0 },
        secondApplianceCounts: appliances2.project,
        squareFootage: +f.buildingFootage || 0,
        secondSquareFootage: +f.buildingFootage2 || 0,
        status: null,
        workSiteContact
    };

    let model = {
        CafeData,
        CustomerSubType: f.isOwner,//f.customerType,
        IsEmailNewsAllowed: (f.electronicCommunicationfromMarketing_UpdatesEmail && f.electronicCommunicationfromMarketing_UpdatesEmail == 1),
        IsEmailNotificationAllowed: (f.electronicCommunicationfromMarketing_NotificationEmail && f.electronicCommunicationfromMarketing_NotificationEmail == 1),
        IsNotSureAboutAppliances: f.notSure == 1,
        IsNotSureSecondAppliances: f.notSure2 == 1,
        //IsResumeProject: $scope.isResumedRequest,
        IsTanentSelected: (f.isOwner && f.isOwner == 5),
        Project,
        ProjectEmail: (f.projectNotificationsEmail_IsSame == 1) ? "" : (f.projectNotificationsEmail ? f.projectNotificationsEmail : ""),
        //Address: selectedAddress(state),
        ProductType: 0,
        IsCustomerSpecifiedSchedule: f.isCustomerSpecifiedDate,
        ScheduleUpdated: g.project && g.project.scheduleUpdated,
        AdditionalNotes: f.additionalNotes,
        RequiredBy: f.requiredByDate,
        HeatingSystem: f.heatingSystem,
        AgeOfProperty: f.ageOfProperty,
        IsSameWorkSiteContact: (state.form.workSiteContact == "1")
    };
    return model;
};
const selectProjectModelServiceRemoval = (state) => {

    const PrimarySiteContact = (state.form.workSiteContact == "1") ?
        {
            CompanyName: state.form.accountHolderInfo_businessInfo_businessName,
            Name: state.form.accountHolderInfo_residentInfo_firstName + " " + state.form.accountHolderInfo_residentInfo_lastName,
            WorkPhone: util.formatCafePhoneNumber(state.form.accountHolderInfo_phoneContact_primaryPhone + state.form.accountHolderInfo_phoneContact_primaryPhone_ext),
            CellPhone: util.formatCafePhoneNumber(state.form.accountHolderInfo_phoneContact_primaryCellPhone)
        }
        :
        {
            CompanyName: state.form.workSiteContactName,
            Name: state.form.workSiteContactName,
            WorkPhone: util.formatCafePhoneNumber(state.form.workSiteContactPhone + state.form.workSiteContactPhone_ext),
            CellPhone: util.formatCafePhoneNumber(state.form.workSiteCellPhone),
        };
    let model = {
        Project: {
            WorkSiteContact: {
                Position: state.form.workSiteContactPoistion
            }
        },
        CafeData: {
            ProjectNo: state.gas.project && state.gas.project.data && state.gas.project.data.projectNo,
            //    BpNumber: $scope.data.customer.bpNumber,
            IsNewBp: (state.form.fortisBCAccount && state.form.fortisBCAccount == 1),
            //    BaNumber: $scope.data.businessAgreement.baNumber,
            IsBusiness: (state.form.customerType && state.form.customerType != "1"),
            IsBuilder: (state.form.customerType && state.form.customerType == "3"),
            ServiceOrders: [{
                StartDate: state.gas.schedule && state.gas.schedule.clickStartDate,
                EndDate: state.gas.schedule && state.gas.schedule.clickEndDate,
                ScheduleStartDate: state.gas.schedule && state.gas.schedule.scheduleStartDate,
                ScheduleEndDate: state.gas.schedule && state.gas.schedule.scheduleEndDate,
            }],
           
            MeterSize: state.gas.sapPremise && state.gas.sapPremise.meterSize,
            MeterNumber: state.gas.sapPremise && state.gas.sapPremise.meterNumber,
            MoveoutDate: state.gas.sapPremise && state.gas.sapPremise.moveoutDate,
            PrimarySiteContact,
            Built1990: state.form.Built1990 == '1' ? 'Y' : 'N',
            WillActiveConstruction: state.form.WillActiveConstruction == '1' ? 'Y' : 'N',
            HazardousMaterialsReport: !state.form.HazardousMaterialsReport ? '' : state.form.HazardousMaterialsReport == '1' ? 'Y' : 'N',
        },
        CustomerSubType: state.form.isOwner,//state.form.customerType,
        IsTanentSelected: (state.form.isOwner && state.form.isOwner == 5),
        //    StepName: stepName,         
        // IsResumeProject: $scope.isResumedRequest,
        IsEmailNotificationAllowed: (state.form.electronicCommunicationfromMarketing_NotificationEmail && state.form.electronicCommunicationfromMarketing_NotificationEmail == 1),
        IsEmailNewsAllowed: (state.form.electronicCommunicationfromMarketing_UpdatesEmail && state.form.electronicCommunicationfromMarketing_UpdatesEmail == 1),
        ProjectEmail: (state.form.projectNotificationsEmail_IsSame == 1) ? "" : (state.form.projectNotificationsEmail ? state.form.projectNotificationsEmail : ""),
        Address: selectedAddress(state),
        ProductType: 1, // for Abandonment 
        ReasonType: util.getNamebyId(window.osa.lookup.serviceAddress.reasonTypes.items, state.form.reasonType),
        DemolishType: state.form.reasonType == 1 ? util.getNamebyId(window.osa.lookup.serviceAddress.demolishReasonTypes.items, state.form.demolishReasonType) : '',
        OtherReasonsDesc: state.form.otherReasons,
        IsBuildingVacant: (state.form.vacantType && state.form.vacantType == '1'),
        IsCustomerSpecifiedSchedule: state.form.isCustomerSpecifiedDate,
        ScheduleUpdated: state.gas.project && state.gas.project.scheduleUpdated,
        AdditionalNotes: state.form.additionalNotes,
        RequiredBy: state.form.requiredByDate,
        IsSameWorkSiteContact: (state.form.workSiteContact == "1")
    };
    return model;
};
const getAppliances = (form, n) => {
    const appliances = window.osa.lookup.projectSpecifics.gasAppliances.items;
    let toRetCafe = [];
    let toRetProject = [];
    let two = n ? '2' : '';
    for (let i = 0; i < appliances.length; i++) {
        let name = appliances[i].name + two;
        toRetCafe.push({
            Quantity: form[name] || 0,
            Type: appliances[i].name
        });
        toRetProject.push({
            id: 0,
            count: +form[name] || 0,
            appliance: { id: (i + 1), name: appliances[i].name, sortOrder: (i + 1) }
        });
    }
    return { cafe: toRetCafe, project: toRetProject };
};
const getAddressForProject = (address) => {
    return {
        addressSubType: { id: 0, name: null, sortOrder: 0 },
        addressType: { id: 1, name: "Project Address1", sortOrder: 1 },
        city: { id: 0, name: address.city, sortOrder: 0 },
        coordinate: { id: 0, lat: 0, lng: 0 },
        country: { id: 0, name: address.country },
        id: 0,
        poBox: null,
        postCode: address.postCode,
        province: { id: 0, name: address.province },
        streetDirection: { name: address.streetDirection || "" },
        streetName: address.streetName || "",
        streetNumber: address.streetNumber || "",
        streetType: { id: 0, name: address.streetType || "", sortOrder: 0 },
        unitNumber: address.unitNumber || "",
    };
};
const getObstacleDescription = (state) => {
    const obsItems = window.osa.lookup.projectSpecifics.obstacles.items;
    let toRet = "";
    for (let i = 0; i < obsItems.length; i++) {
        if (state.form[obsItems[i].name] == "1")
            toRet += obsItems[i].name + ",";
    }

    if (state.form['OtherObstacle']) toRet += state.form['OtherObstacle'];
    return toRet;
};
export {
    selectProjectModel
};